const PROPOSAL_PERIODS = {
  DAYS: "days",
  WEEKS: "weeks",
  MONTHS: "months",
  YEARS: "years"
} as const

type ProposalPeriodsKeys = keyof typeof PROPOSAL_PERIODS
type ProposalPeriods = (typeof PROPOSAL_PERIODS)[ProposalPeriodsKeys]

const PROPOSAL_PERIODS_OBJ: Record<
  string,
  {
    id: ProposalPeriods
    value: ProposalPeriods
    label: string
  }
> = {
  [PROPOSAL_PERIODS.DAYS]: {
    id: PROPOSAL_PERIODS.DAYS,
    value: PROPOSAL_PERIODS.DAYS,
    label: "Days"
  },
  [PROPOSAL_PERIODS.WEEKS]: {
    id: PROPOSAL_PERIODS.WEEKS,
    value: PROPOSAL_PERIODS.WEEKS,
    label: "Weeks"
  },
  [PROPOSAL_PERIODS.MONTHS]: {
    id: PROPOSAL_PERIODS.MONTHS,
    value: PROPOSAL_PERIODS.MONTHS,
    label: "Months"
  },
  [PROPOSAL_PERIODS.YEARS]: {
    id: PROPOSAL_PERIODS.YEARS,
    value: PROPOSAL_PERIODS.YEARS,
    label: "Years"
  }
}

const PROPOSAL_PERIODS_MAP = Object.fromEntries(
  Object.values(PROPOSAL_PERIODS_OBJ).map((item) => [item.label, item])
) as Record<
  string,
  (typeof PROPOSAL_PERIODS_OBJ)[keyof typeof PROPOSAL_PERIODS_OBJ]
>

const PROPOSAL_PERIODS_SELECT_OPTIONS = Object.values(PROPOSAL_PERIODS_OBJ).map(
  ({ value, label }) => ({ value, label })
)

export {
  PROPOSAL_PERIODS,
  PROPOSAL_PERIODS_OBJ,
  PROPOSAL_PERIODS_SELECT_OPTIONS,
  PROPOSAL_PERIODS_MAP,
  type ProposalPeriods
}
